import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "menu_settings",
  class: "app-sidebar__group"
}
const _hoisted_2 = { class: "app-sidebar__submenu" }
const _hoisted_3 = {
  key: 1,
  id: "menu_admin",
  class: "app-sidebar__group app-sidebar__group--admin"
}
const _hoisted_4 = { class: "app-sidebar__submenu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_slide_transition = _resolveComponent("q-slide-transition")!
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createBlock(_component_q_list, { class: "app-sidebar q-scrollarea__container scroll relative-position" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleMainLinks, (item) => {
        return (_openBlock(), _createBlock(_component_q_item, {
          key: item.key,
          id: item.id,
          "data-testid": item.testId,
          class: _normalizeClass(["btn tw-sidebar-btn items-center app-sidebar__item", { 'app-sidebar__item--active classHover': _ctx.isModuleActive(item.module) }]),
          clickable: "",
          to: item.to,
          onClick: _ctx.hide
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_icon, {
              name: item.icon,
              color: _ctx.iconColor(item.module),
              size: "20px",
              class: "app-sidebar__icon"
            }, null, 8, ["name", "color"]),
            _createVNode(_component_q_item_label, {
              class: _normalizeClass(_ctx.labelClass(item.module))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.menuLabel(item.role)), 1)
              ]),
              _: 2
            }, 1032, ["class"])
          ]),
          _: 2
        }, 1032, ["id", "data-testid", "class", "to", "onClick"]))
      }), 128)),
      (_ctx.settingsSectionVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_q_item, {
              class: "btn tw-sidebar-btn items-center app-sidebar__item app-sidebar__item--parent",
              clickable: "",
              onClick: _ctx.openSection
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "settings",
                  color: "grey-7",
                  size: "20px",
                  class: "app-sidebar__icon"
                }),
                _createVNode(_component_q_item_label, { class: "app-sidebar__label text-grey-8" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.menuLabel(_ctx.MenuRoles.ROLE_MENU_SETTINGS)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_icon, {
                  name: "expand_more",
                  size: "18px",
                  color: "grey-6",
                  class: _normalizeClass(["app-sidebar__chevron q-ml-auto", { 'app-sidebar__chevron--open': _ctx.openConfiguration }])
                }, null, 8, ["class"])
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_q_slide_transition, null, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleSettingsChildren, (child) => {
                    return (_openBlock(), _createBlock(_component_q_item, {
                      key: child.key,
                      id: child.id,
                      class: _normalizeClass(["btn tw-sidebar-btn items-center app-sidebar__subitem", { 'app-sidebar__subitem--active classHover': _ctx.isModuleActive(child.module) }]),
                      clickable: "",
                      to: child.to,
                      onClick: _ctx.hide
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["app-sidebar__dot", { 'app-sidebar__dot--active': _ctx.isModuleActive(child.module) }])
                        }, null, 2),
                        _createVNode(_component_q_item_label, {
                          class: _normalizeClass(_ctx.labelClass(child.module, true))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.menuLabel(child.role)), 1)
                          ]),
                          _: 2
                        }, 1032, ["class"])
                      ]),
                      _: 2
                    }, 1032, ["id", "class", "to", "onClick"]))
                  }), 128))
                ], 512), [
                  [_vShow, _ctx.openConfiguration]
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.adminSectionVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_q_item, {
              class: "btn tw-sidebar-btn items-center app-sidebar__item app-sidebar__item--parent",
              clickable: "",
              onClick: _ctx.openUserAdminSection
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "manage_accounts",
                  color: "grey-7",
                  size: "20px",
                  class: "app-sidebar__icon"
                }),
                _createVNode(_component_q_item_label, { class: "app-sidebar__label text-grey-8" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.menuLabel(_ctx.MenuRoles.ROLE_MENU_ADMIN)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_icon, {
                  name: "expand_more",
                  size: "18px",
                  color: "grey-6",
                  class: _normalizeClass(["app-sidebar__chevron q-ml-auto", { 'app-sidebar__chevron--open': _ctx.openUserAdmin }])
                }, null, 8, ["class"])
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_q_slide_transition, null, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleAdminChildren, (child) => {
                    return (_openBlock(), _createBlock(_component_q_item, {
                      key: child.key,
                      id: child.id,
                      class: _normalizeClass(["btn tw-sidebar-btn items-center app-sidebar__subitem", { 'app-sidebar__subitem--active classHover': _ctx.isModuleActive(child.module) }]),
                      clickable: "",
                      to: child.to,
                      onClick: _ctx.hide
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["app-sidebar__dot", { 'app-sidebar__dot--active': _ctx.isModuleActive(child.module) }])
                        }, null, 2),
                        _createVNode(_component_q_item_label, {
                          class: _normalizeClass(_ctx.labelClass(child.module, true))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.menuLabel(child.role)), 1)
                          ]),
                          _: 2
                        }, 1032, ["class"])
                      ]),
                      _: 2
                    }, 1032, ["id", "class", "to", "onClick"]))
                  }), 128))
                ], 512), [
                  [_vShow, _ctx.openUserAdmin]
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}